
import React, { useState } from 'react';
import './columContainer.css';

const ColumContainer = ({ title, children, isRow }) => {
  const [isVariant, setIsVariant] = useState(false);

  return (
    <>
      {!isRow ? (<>
        <div className="column_container">
          <div className="column_title">
            {title}
          </div>
          <div>
            {children}
          </div>
        </div>
      </>) : (
        <>
          <div className="column_container">
            <div className="column_title">
              {title}
            </div>
            <div className="column-row">
              {children}
            </div>
          </div>
        </>
      )
      }

    </>

  )
}

export default ColumContainer;